<template>
  <div class="app p-0">
    <router-view />
  </div>
  <!-- <div class="app p-0 m-0">
    <div>
      <MainMenu />
      <PopUp />
    </div>
    <div class="main pt-5">
      <router-view class="page-wrapper"  :key="$route.name" />
    </div>
  </div> -->
</template>

<script>
import MainMenu from "./components/MainMenu.vue";
import PopUp from "./components/popups/PopUps.vue";
import { mapActions, mapGetters } from "vuex";

// import WsSubscriptions from "./serve/websocket";
// import Auth from "./utils/auth";

export default {
  name: "Home",
  components: { MainMenu, PopUp },
  metaInfo() {
    return {
      title: `Stonebox`,
      meta: [
        {  name: "description",  content: "Sua plataforma ddo cliénte",},{  property: "og:title",  content: `Stonebox`,},
        { property: "og:site_name", content: "Stonebox" },
        {  property: "og:description",  content: "Sua plataforma ddo cliénte",},
        { property: "og:type", content: "profile" },
        {  property: "og:url",  content: `${process.env.VUE_APP_API_BASE_URL}`},
        { property: 'og:image', content: `https://stonebox.app.br/images/1630681146546-stone_176-54.jpg`  }    

      ],
    };
  },
};
</script>

<style lang="scss">
@import "./assets/styles/variables";
@import "./assets/styles/bootstrap";
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,600;1,500&display=swap");

.app {
  font-family: "Poppins", sans-serif, "Avenir Next W01", "Lato", "Karla",
    "Proxima Nova W01", "Rubik", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial;
  // font-family: 'Roboto', sans-serif;
  color: #444;
  .rounded {
    border-radius: 0.6rem !important;
  }
  .shadow-sm {
    animation: pulse 500ms;
  }

  ul {
    list-style-type: none;
  }

  .btn-dark{
    background-color: #333333;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.7);
    }
    100% {
      transform: scale(1);
    }
  }
  legend {
    font-size: 18px;
    font-weight: 300;
    color: #444;
  }
  input {
    border-radius: 0.5rem;
  }

  .divider-top{
    border-top: 1px solid #f1f1f1f1
  }

  .page-wrapper {
    margin: 0 auto;
    max-width: 1440px;
    width: 100%;

    display: grid;
    grid-template-columns: 100%;
  }

  @media (max-width: 1440px) {
    .page-wrapper {
      max-width: 1220px;
    }
  }
}


// .app {
//   // display: flex;
//   background-color: #fafafa;
//   flex-direction: row;
//   height: 100%;
//   overflow: inherit !important;

//   .main {
//     // background-color: #f8f9fa;
//     width: 100vw;
//     height: calc(100vh - 65px);

//     overflow-x: auto;
//     padding: 0 1rem 0 1rem;
//   }
// }
</style>
